import 'bootstrap/dist/css/bootstrap.min.css';
import ClipDart from './ClipDart';

function App() {
  return (
    <div className="App">
      <ClipDart />
    </div>
  );
}

export default App;
